import { render, staticRenderFns } from "./MyCommentList.vue?vue&type=template&id=a647f3a0&scoped=true&"
import script from "./MyCommentList.vue?vue&type=script&lang=ts&"
export * from "./MyCommentList.vue?vue&type=script&lang=ts&"
import style0 from "./MyCommentList.vue?vue&type=style&index=0&id=a647f3a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a647f3a0",
  null
  
)

export default component.exports